import serviceDiscovery from '@pcln/service-disco';
import pclnConfig from '@pcln/config';

// @ts-ignore

var cleanSlashes = function cleanSlashes(str) {
  return str.replace(/(^\/)|(\/$)/g, '');
};

function legacyServiceResolveURL(serviceName, endpoint, _ref) {
  var _pclnConfig$datacente, _pclnConfig$datacente2;

  var dc = _ref.dc,
      env = _ref.env;
  var hosts = ((_pclnConfig$datacente = pclnConfig.datacenters) === null || _pclnConfig$datacente === void 0 ? void 0 : (_pclnConfig$datacente2 = _pclnConfig$datacente[dc]) === null || _pclnConfig$datacente2 === void 0 ? void 0 : _pclnConfig$datacente2[env]) || {};
  var serviceMapping = {
    baseUrl: hosts.baseUrl,
    baseUrlSecure: hosts.baseUrlSecure,
    services: pclnConfig.services
  };
  var serviceConfig = serviceMapping.services[serviceName];

  if (!serviceConfig) {
    throw new Error("Service configuration for " + serviceName + " could not be found.  Please check the name of the service");
  }

  var uri = serviceConfig.uri,
      f5Type = serviceConfig.f5Type;
  var baseConfig = serviceConfig.secure ? serviceMapping.baseUrlSecure : serviceMapping.baseUrl;
  var baseURL = baseConfig instanceof Object ? baseConfig[f5Type] : baseConfig;

  if (!baseURL || baseURL === '/') {
    throw new Error('Could not locate datacenter configuration. Check env vars BOOTSTRAP_ENV and BOOTSTRAP_DC or @pcln/config');
  }

  return cleanSlashes(baseURL) + "/" + cleanSlashes(uri) + (endpoint ? '/' + cleanSlashes(endpoint) : '');
}
function buildServiceURL(serviceName, endpoint, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$protocol = _ref2.protocol,
      protocol = _ref2$protocol === void 0 ? 'https' : _ref2$protocol,
      _ref2$useDiscovery = _ref2.useDiscovery,
      useDiscovery = _ref2$useDiscovery === void 0 ? true : _ref2$useDiscovery,
      _ref2$dc = _ref2.dc,
      dc = _ref2$dc === void 0 ? process.env['BOOTSTRAP_DC'] : _ref2$dc,
      _ref2$env = _ref2.env,
      env = _ref2$env === void 0 ? process.env['BOOTSTRAP_ENV'] : _ref2$env;

  if (!dc || !env) {
    throw new Error('Service resolution requires the existence of BOOTSTRAP_DC and BOOTSTRAP_ENV.  Please ensure these are available');
  }

  if (useDiscovery) {
    var hostName = serviceDiscovery(serviceName, {
      dc: dc,
      env: env === null || env === void 0 ? void 0 : env.replace(/-/, '')
    });
    return protocol + "://" + cleanSlashes(hostName) + "/" + cleanSlashes(endpoint);
  } else {
    return legacyServiceResolveURL(serviceName, endpoint, {
      dc: dc,
      env: env
    });
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function extractPricelineHeaders(_ref) {
  var _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;
  return Object.keys(headers).filter(function (header) {
    return header.indexOf('x-pcln-') > -1;
  }).reduce(function (a, v) {
    a[v] = headers[v];
    return a;
  }, {});
}
function passThroughPricelineHeaders(request, _ref2) {
  var adapter = _ref2.adapter;
  return function (event) {
    var currentHeaders = adapter.get(event);
    var pricelineHeaders = extractPricelineHeaders(request);
    return adapter.set(event, _extends(_extends({}, currentHeaders), pricelineHeaders));
  };
}

var axiosInteceptorAdapter = {
  get: function get(config) {
    return config;
  },
  set: function set(config, headers) {
    config.headers = headers;
    return headers;
  }
};

var thwackInterceptorAdapter = {
  get: function get(event) {
    return event.options;
  },
  set: function set(event, headers) {
    event.options.headers = headers;
    return event;
  }
};

export { axiosInteceptorAdapter, buildServiceURL, extractPricelineHeaders, legacyServiceResolveURL, passThroughPricelineHeaders, thwackInterceptorAdapter };
//# sourceMappingURL=common-request-functions.esm.js.map
